import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../app/globals.css";
import { AuthenticatedApp } from "../app/components/authenticated-app";
import "./posthog";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Application root element was not found.");

createRoot(rootElement).render(
	<StrictMode>
		<AuthenticatedApp />
	</StrictMode>,
);
